/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */
import * as React from 'react';
import withIntl from './injectIntl';

var FormattedPlural = function FormattedPlural(props) {
  var value = props.value,
      other = props.other,
      children = props.children,
      _props$intl = props.intl,
      formatPlural = _props$intl.formatPlural,
      Text = _props$intl.textComponent;
  var pluralCategory = formatPlural(value, props);
  var formattedPlural = props[pluralCategory] || other;

  if (typeof children === 'function') {
    return children(formattedPlural);
  }

  if (Text) {
    return React.createElement(Text, null, formattedPlural);
  } // Work around @types/react where React.FC cannot return string


  return formattedPlural;
};

FormattedPlural.defaultProps = {
  type: 'cardinal'
};
FormattedPlural.displayName = 'FormattedPlural';
export default withIntl(FormattedPlural);